import type { ThemeType } from "@pandas/core-ui";
import { ReactNode } from "react";
import LoadingDots from "@/components/LoadingDots";
import { useStore } from "@/store";
export interface Props {
	themeMode?: ThemeType;
	intent?: "primary" | "secondary" | "tertiary" | "quaternary" | "input";
	size?: "small" | "medium" | "large";
	label: string | ReactNode;
	disabled?: boolean;
	loader?: boolean;
	onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function Button({ themeMode, intent, size, label, disabled = false, loader, onClick }: Props) {
	const theming = useStore((state) => state.config?.theming);

	themeMode = themeMode ?? "light";
	intent = intent ?? "primary";
	size = size ?? "medium";

	const darkColor = "#FFFFFF";
	const themeColor = themeMode === "light" ? theming?.brandColor : darkColor;
	const backgroundColor = themeMode === "light" ? "white" : "#18181b";
	const height =
		intent === "input"
			? "min-h-12 sm:min-h-[88px]"
			: intent === "tertiary"
				? "min-h-[3.125rem]"
				: size === "large"
					? "min-h-[4.5rem] sm:min-h-[6rem]"
					: "min-h-14 sm:min-h-[4.5rem]";
	const width =
		intent === "input"
			? "min-w-12 max-w-12 sm:min-w-[88px]"
			: `${
					size === "small"
						? "[min-width:min(17.5rem,100%)] sm:min-w-[17.5rem]"
						: "[min-width:min(18rem,100%)] sm:min-w-[18rem] lg:min-w-[20rem]"
				} `;
	const background = intent === "primary" || intent === "input" ? `${themeColor}` : backgroundColor;
	const textColor =
		intent === "primary" || intent === "input" ? (themeMode === "dark" ? "black" : "white") : `${themeColor}`;
	const fontSize = intent === "input" ? "" : size === "large" ? "text-xl sm:text-2xl" : "text-base sm:text-xl";
	const border =
		intent === "input" ? "" : intent === "quaternary" ? (size === "small" ? "" : "sm:border-2") : `border-2`;
	const borderRadius = intent === "input" ? "0.375rem" : theming?.buttonBorderRadius;

	return (
		<>
			<button
				onClick={onClick}
				disabled={disabled}
				style={{
					background: disabled ? undefined : background,
					color: disabled ? undefined : textColor,
					borderColor: disabled ? undefined : themeColor,
					borderRadius: borderRadius,
				}}
				className={`${width} w-fit h-fit ${height} ${fontSize} ${border} ${
					intent === "input" ? "p-0" : "px-4"
				} text-center font-medium disabled:bg-btn-disabled disabled:border-btn-disabled disabled:text-btn-disabled-text disabled:cursor-not-allowed whitespace-normal break-words`}
			>
				{loader ? <LoadingDots size={intent === "input" ? "small" : "medium"} /> : label}
			</button>
		</>
	);
}
